import {MODAL_KEY} from './reducer'
import {ModalID as ModalIDType, Payload} from './types'

export const ModalID = <T>(id: string) => {
  return `modal/${id}` as ModalIDType<T>
}

export const getModalByID = <T>(modalID: ModalIDType<T>) => {
  return (state: Record<typeof MODAL_KEY | string, any>): Payload<T> => {
    return state[MODAL_KEY][modalID]
  }
}
